/* SIX: Kopf (Kompaktmodus, Suche mit Vorschlägen, Handy-Menü). Broadcast steuert Warenkorb, Varianten und Consent. */
(() => {
  if (window.__sixUx) return;
  window.__sixUx = true;
  // Beim Runterscrollen kompakter Kopf (Handy: ohne Suchzeile, Desktop: ohne Service-Leiste), beim Hochscrollen wieder alles.
  const mq = window.matchMedia('(min-width: 0px)'); // Kompaktmodus auf allen Breiten (Handy: Suchzeile, Desktop: Service-Leiste)
  const root = document.documentElement;
  const headerEl = () => document.querySelector('[data-header-height]');
  const headerH = () => { const h = headerEl(); return h ? Math.round(h.getBoundingClientRect().height) : 0; };
  // Wichtig: --header-height (Theme) wird hier NIE geändert. Davon hängt der Platzhalter
  // .header__backfill ab; ihn zu verkleinern verschiebt den Inhalt, der Browser korrigiert
  // scrollY und das sähe wie Hochscrollen aus (Regression 08.10.: 600 -> 538 -> wieder groß).
  // Eigene Variablen: --six-header-full (Platzhalter, immer volle Höhe) und
  // --six-header-offset (sichtbare Höhe, für die Sticky-Filterleiste).
  function syncVars() {
    const h = headerH(); if (!h) return;
    if (!root.classList.contains('six-header-compact')) root.style.setProperty('--six-header-full', h + 'px');
    root.style.setProperty('--six-header-offset', h + 'px');
  }
  // Trustpilot/Showroom-Leiste (Section „section-mobile-header-promo“) in den Kopf hängen, direkt ÜBER
  // .six-hdr (Felix 10.10.) – so bleibt sie beim Scrollen mit dem Kopf sichtbar. Nur das <section>-Element wandert;
  // Styles (per ID), Einstellungen und Links bleiben unverändert. Ab 750px blendet ihre eigene Regel sie aus.
  // Verschieben und Neumessen im selben Schritt -> kein Inhaltssprung (Platzhalter = volle Kopfhöhe).
  function dockPromo() {
    const hdr = document.querySelector('.theme__header .six-hdr'); if (!hdr) return;
    // Nur Leisten, die noch in ihrer eigenen Section stehen (nicht schon angedockte).
    document.querySelectorAll('.shopify-section section.mobile-header-promo:not(.six-promo-docked)').forEach(bar => {
      document.querySelectorAll('section.mobile-header-promo.six-promo-docked').forEach(old => { if (old !== bar && old.id === bar.id) old.remove(); });
      bar.classList.add('six-promo-docked');
      hdr.before(bar);
    });
    syncVars();
  }
  // Theme-Editor: vor dem Neuladen des Kopfes die Leiste in ihre Section zurückgeben, danach neu andocken.
  function undockPromo() {
    document.querySelectorAll('section.mobile-header-promo.six-promo-docked').forEach(bar => {
      const home = document.getElementById('shopify-section-' + bar.dataset.sectionId);
      if (home && !home.contains(bar)) { bar.classList.remove('six-promo-docked'); home.appendChild(bar); } else if (!home) bar.remove();
    });
  }
  dockPromo();
  document.addEventListener('shopify:section:unload', e => {
    if (e.target.querySelector('.six-hdr')) { undockPromo(); return; }
    const sid = e.target.id && e.target.id.replace('shopify-section-', '');
    document.querySelectorAll('section.mobile-header-promo.six-promo-docked').forEach(b => { if (b.dataset.sectionId === sid) b.remove(); });
    syncVars();
  });
  document.addEventListener('shopify:section:load', e => { if (e.target.querySelector('.six-hdr, section.mobile-header-promo')) dockPromo(); });
  // Richtung mit Hysterese: erst ab 24px Weg in eine Richtung umschalten.
  let anchorY = window.scrollY, lastY = window.scrollY, dir = 0, ticking = false;
  function setCompact(next) {
    if (next === root.classList.contains('six-header-compact')) return;
    root.classList.toggle('six-header-compact', next);
    syncVars();
    anchorY = lastY = window.scrollY; dir = 0;
  }
  window.addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      const y = window.scrollY;
      const menuOpen = document.querySelector('.drawer.is-open, [data-drawer].is-open, header-search-popdown details[open], .header__wrapper details[open], .six-hdr .header__menu [aria-expanded="true"], .six-search__results:not([hidden])') || (document.activeElement && document.activeElement.classList.contains('six-search__input'));
      if (!mq.matches || y < 140 || menuOpen) { setCompact(false); lastY = anchorY = y; return; }
      const d = y > lastY ? 1 : (y < lastY ? -1 : 0);
      if (d && d !== dir) { dir = d; anchorY = lastY; }
      lastY = y;
      if (dir > 0 && y - anchorY > 24) setCompact(true);
      else if (dir < 0 && anchorY - y > 24) setCompact(false);
    });
  }, {passive: true});
  // Offset (sichtbare Höhe) bei jedem Resize neu; bei Breitenwechsel auch die volle Höhe – dafür kurz
  // ausgeklappt messen (gleicher Frame, kein sichtbares Umschalten). Reine Höhenänderungen (iOS-Adressleiste)
  // klappen den Kopf nicht auf.
  let lastW = window.innerWidth;
  window.addEventListener('resize', () => {
    const compact = root.classList.contains('six-header-compact');
    if (window.innerWidth !== lastW && compact) {
      root.classList.remove('six-header-compact'); syncVars(); root.classList.add('six-header-compact');
    }
    lastW = window.innerWidth;
    syncVars();
  }, {passive: true});
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncVars); else syncVars();
  window.addEventListener('load', () => { if (!root.classList.contains('six-header-compact')) syncVars(); });

  /* ===== SIX-Kopf: Suche mit Vorschlägen ===== */
  const lang = (document.documentElement.lang || 'de').slice(0, 2);
  const esc = t => String(t == null ? '' : t).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = v => { const n = Number(v); if (!isFinite(n)) return ''; const f = n.toLocaleString(lang === 'en' ? 'en-GB' : 'de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2}); return lang === 'en' ? '€' + f : f + '€'; };

  // Preise in den Vorschlägen: Shopify liefert dort nur den Mindestpreis aller Varianten – bei Stühlen
  // ist das das Ledermuster (10€). Deshalb echte Varianten laden und Muster-Varianten ausschließen.
  const priceCache = {};
  const SAMPLE = /muster|sample|échantillon|echantillon/i;
  function realPrice(handle) {
    if (!priceCache[handle]) {
      const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      priceCache[handle] = fetch(`${base}products/${encodeURIComponent(handle)}.js`).then(r => r.ok ? r.json() : null).then(p => {
        if (!p) return '';
        const prices = p.variants.filter(v => !SAMPLE.test(v.title || '')).map(v => v.price);
        if (!prices.length) return '';
        const min = Math.min.apply(null, prices), varies = prices.some(x => x !== min);
        return (varies ? (window.__sixNavT && window.__sixNavT.from || '') + ' ' : '') + money(min / 100);
      }).catch(() => '');
    }
    return priceCache[handle];
  }
  function fillPrices(box) { box.querySelectorAll('[data-six-price]').forEach(el => realPrice(el.dataset.sixPrice).then(t => { el.textContent = t.trim(); })); }
  function initSearch(form) {
    if (form.dataset.sixBound) return; form.dataset.sixBound = '1';
    const input = form.querySelector('.six-search__input'), box = form.querySelector('.six-search__results'), clear = form.querySelector('.six-search__clear');
    const T = window.__sixNavT || {};
    let timer, ctrl, active = -1;
    const opts = () => Array.from(box.querySelectorAll('[role="option"]'));
    const close = () => { box.hidden = true; input.setAttribute('aria-expanded', 'false'); input.removeAttribute('aria-activedescendant'); active = -1; };
    // Höhe der Liste an den Platz unter dem Feld anpassen (Handy-Tastatur, Kompaktmodus)
    const fit = () => { const vh = window.visualViewport ? window.visualViewport.height : window.innerHeight; const top = form.getBoundingClientRect().bottom + 6; box.style.setProperty('--six-sr-max', Math.max(160, Math.round(vh - top - 12)) + 'px'); };
    const open = () => { fit(); box.hidden = false; input.setAttribute('aria-expanded', 'true'); };
    if (window.visualViewport) window.visualViewport.addEventListener('resize', () => { if (!box.hidden) fit(); });
    function mark(i) { const o = opts(); o.forEach(x => x.setAttribute('aria-selected', 'false')); active = i; if (o[i]) { o[i].setAttribute('aria-selected', 'true'); input.setAttribute('aria-activedescendant', o[i].id); o[i].scrollIntoView({block: 'nearest'}); } }
    function render(q, data) {
      const r = (data && data.resources && data.resources.results) || {};
      const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      const id = (k, i) => `${input.id}-o-${k}-${i}`;
      let html = '';
      if ((r.queries || []).length) html += `<p class="six-sr__h">${esc(T.suggestions)}</p>` + r.queries.slice(0, 4).map((x, i) => `<a role="option" id="${id('q', i)}" class="six-sr__opt" href="${esc(x.url)}">${x.styled_text || esc(x.text)}</a>`).join('');
      if ((r.collections || []).length) html += `<p class="six-sr__h">${esc(T.categories)}</p>` + r.collections.slice(0, 3).map((x, i) => `<a role="option" id="${id('c', i)}" class="six-sr__opt" href="${esc(x.url)}">${esc(x.title)}</a>`).join('');
      if ((r.products || []).length) html += `<p class="six-sr__h">${esc(T.products)}</p>` + r.products.slice(0, 6).map((x, i) => `<a role="option" id="${id('p', i)}" class="six-sr__opt" href="${esc(x.url)}">${x.image ? `<img src="${esc(x.image)}&width=96" alt="" width="48" height="48" loading="lazy">` : ''}<span>${esc(String(x.title).replace(/^SIX\s+/, ''))}<small data-six-price="${esc(x.handle)}"></small></span></a>`).join('');
      if (!html) {
        const links = Array.from(document.querySelectorAll('.six-hdr .header__menu a.navlink--toplevel, .six-hdr .six-hdr__pro')).map(a => `<li><a href="${esc(a.getAttribute('href'))}">${esc(a.textContent.trim().replace(/\s+/g, ' '))}</a></li>`).join('');
        html = `<p class="six-sr__empty">${esc((T.no_results || '').replace('%TERMS%', q))}</p><ul class="six-sr__chips" role="list">${links}</ul>`;
      } else {
        html += `<a class="six-sr__all" role="option" id="${id('all', 0)}" href="${base}search?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last">${esc((T.search_all || '').replace('%TERMS%', q))}</a>`;
      }
      box.innerHTML = html; active = -1; open();
      fillPrices(box);
    }
    input.addEventListener('input', () => {
      const q = input.value.trim(); clear.hidden = !input.value; clearTimeout(timer);
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => {
        if (ctrl) ctrl.abort(); ctrl = new AbortController();
        const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        fetch(`${base}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=query,collection,product&resources[limit]=6&resources[options][unavailable_products]=last`, {signal: ctrl.signal})
          .then(res => res.json()).then(d => { if (input.value.trim() === q) render(q, d); }).catch(() => {});
      }, 200);
    });
    input.addEventListener('keydown', e => {
      const o = opts();
      if (e.key === 'ArrowDown' && o.length) { e.preventDefault(); if (box.hidden) open(); mark(Math.min(active + 1, o.length - 1)); }
      else if (e.key === 'ArrowUp' && o.length) { e.preventDefault(); mark(Math.max(active - 1, 0)); }
      else if (e.key === 'Enter' && active >= 0 && o[active]) { e.preventDefault(); location.assign(o[active].href); }
      else if (e.key === 'Escape') { if (!box.hidden) { e.preventDefault(); close(); } else if (input.value) { input.value = ''; clear.hidden = true; } }
    });
    input.addEventListener('focus', () => { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    clear.addEventListener('click', () => { input.value = ''; clear.hidden = true; close(); input.focus(); });
    form.addEventListener('submit', e => { if (!input.value.trim()) { e.preventDefault(); input.focus(); } });
    document.addEventListener('click', e => { if (!form.contains(e.target)) close(); });
    clear.hidden = !input.value;
  }

  /* ===== SIX-Handy-Menü: Ebenen ===== */
  function initMnav(nav) {
    if (nav.dataset.sixBound) return; nav.dataset.sixBound = '1';
    const rootLvl = nav.querySelector('[data-six-mnav-root]');
    const scroller = nav.closest('[data-scroll-lock-scrollable]');
    nav.addEventListener('click', e => {
      const cat = e.target.closest('.six-mnav__cat');
      if (cat) {
        const sub = document.getElementById(cat.getAttribute('aria-controls')); if (!sub) return;
        rootLvl.hidden = true; sub.hidden = false; cat.setAttribute('aria-expanded', 'true'); nav.dataset.sixFrom = cat.getAttribute('aria-controls');
        if (scroller) scroller.scrollTop = 0; const back = sub.querySelector('.six-mnav__back'); if (back) back.focus();
        return;
      }
      if (e.target.closest('.six-mnav__back')) {
        const sub = e.target.closest('.six-mnav__sub'); sub.hidden = true; rootLvl.hidden = false;
        const from = nav.querySelector(`.six-mnav__cat[aria-controls="${sub.id}"]`); if (from) { from.setAttribute('aria-expanded', 'false'); from.focus(); }
      }
    });
  }
  function resetMnav() { document.querySelectorAll('[data-six-mnav]').forEach(nav => { nav.querySelectorAll('.six-mnav__sub').forEach(s => s.hidden = true); const r = nav.querySelector('[data-six-mnav-root]'); if (r) r.hidden = false; nav.querySelectorAll('.six-mnav__cat').forEach(c => c.setAttribute('aria-expanded', 'false')); }); }
  document.addEventListener('click', e => { if (e.target.closest('[data-drawer-toggle="hamburger"]')) resetMnav(); }, true);

  // Broadcast öffnet unter 750px den Drawer der Section „mobile-menu“, ab 750px #header-menu.
  // Beide enthalten das neue SIX-Menü; aria-controls/-expanded und Fokus folgen dem tatsächlich genutzten.
  const drawerFor = () => window.matchMedia('(min-width: 750px)').matches ? document.getElementById('header-menu') : document.querySelector('mobile-menu > [data-drawer]');
  function syncBurger() {
    const burger = document.querySelector('.six-hdr__burger'), d = drawerFor();
    if (burger && d && d.id) burger.setAttribute('aria-controls', d.id);
  }
  window.matchMedia('(min-width: 750px)').addEventListener('change', syncBurger);
  function watchDrawer() {
    const burger = document.querySelector('.six-hdr__burger'); if (!burger) return;
    [document.querySelector('mobile-menu > [data-drawer]'), document.getElementById('header-menu')].forEach(drawer => {
      if (!drawer || drawer.dataset.sixWatch) return; drawer.dataset.sixWatch = '1';
      let wasOpen = drawer.classList.contains('is-open');
      new MutationObserver(() => {
        const open = drawer.classList.contains('is-open');
        if (drawer === drawerFor()) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (wasOpen && !open) { resetMnav(); const a = document.activeElement; if (!a || a === document.body || drawer.contains(a)) burger.focus(); }
        wasOpen = open;
      }).observe(drawer, {attributes: true, attributeFilter: ['class']});
    });
  }
  // Kollektion, Handy: Chat-Button (SmartBot, offener Shadow DOM) über die Filter-/Sortierleiste heben.
  // Nur Abstand per eingefügter Regel; die Chat-App selbst bleibt unverändert.
  function liftChat(tries) {
    if (!document.body.classList.contains('template-collection')) return;
    const host = document.getElementById('smart-bot-container');
    if (!host || !host.shadowRoot) { if ((tries || 0) < 20) setTimeout(() => liftChat((tries || 0) + 1), 750); return; }
    if (host.shadowRoot.querySelector('style[data-six-lift]')) return;
    const st = document.createElement('style'); st.dataset.sixLift = '';
    st.textContent = '@media (max-width: 749px) { [class*="chat-icon-container"] { bottom: calc(20px + 58px + env(safe-area-inset-bottom, 0px)) !important; } }';
    host.shadowRoot.appendChild(st);
  }
  liftChat(0);
  // Solange Filter oder Sortierung offen sind: Klasse für das Ausblenden des Chat-Buttons (nur Kollektion).
  function watchNavPanels() {
    const nav = document.querySelector('.template-collection [data-collection-nav]'); if (!nav || nav.dataset.sixWatch) return; nav.dataset.sixWatch = '1';
    const update = () => root.classList.toggle('six-nav-panel-open', !!nav.querySelector('[aria-expanded="true"]'));
    new MutationObserver(update).observe(nav, {subtree: true, attributes: true, attributeFilter: ['aria-expanded']}); update();
  }
  watchNavPanels();
  function initHeader() { syncBurger(); watchDrawer(); document.querySelectorAll('[data-six-search]').forEach(initSearch); document.querySelectorAll('[data-six-mnav]').forEach(initMnav); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHeader); else initHeader();
  document.addEventListener('shopify:section:load', initHeader);
})();
